<template>
    <el-dialog
            :title="title"
            :visible.sync="showFlag"
            width="30%"
            @close="closeDialog"
    >
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入名称" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="路径" prop="path">
                <el-input v-model="form.path" placeholder="请输入访问路径" maxlength="150"></el-input>
            </el-form-item>
            <el-form-item label="编码" prop="code">
                <el-input v-model="form.code" placeholder="请输入编码" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="可见" prop="roleInt">
                <el-checkbox-group v-model="form.roleInt">
                    <el-checkbox :label="1">主账号</el-checkbox>
                    <el-checkbox :label="2">子账号</el-checkbox>
                    <el-checkbox :label="3">采购员</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="状态" prop="state">
                <el-radio-group v-model="form.state">
                    <el-radio :label="2">已启用</el-radio>
                    <el-radio :label="1">未启用</el-radio>
                    <el-radio :label="3">已禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="显示图标" prop="menuIcon">
                <i class="iconfont" :class="form.menuIcon? form.menuIcon : 'iconxinzeng_wpstupian'" @click="changeIcon"></i>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
        <icon-dialog ref="iconDialog"></icon-dialog>
    </el-dialog>
</template>
<script>
    import iconDialog from './icon-dialog'
    export default {
        name: 'menuDialog',
        props: ['title'],
        components: {iconDialog},
        data() {
            return {
                operation: '',
                showFlag: false,
                form: {
                    name: '',
                    code: '',
                    state: 2,
                    menuIcon: '',
                    path: '',
                    roleInt: [1,2,3],
                    leafNode: 1
                },
                rules: {
                    name: [
                        { required: true, message: '请输入菜单名称', trigger: 'blur' }
                    ],
                    path: [
                        { required: true, message: '请输入菜单路径', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            show(item,type) {
                this.operation = type;
                this.showFlag = true;
                if(type === 'add') {
                    //添加
                    if(!item) {
                        this.form.faMenuItem = '~';
                    } else {
                        this.form.faMenuItem = item.pkMenuItem;
                    }
                } else if (type === 'edit') {
                    //修改
                    this.form = item;
                    this.form.roleInt = [];
                    if(item.roles && item.roles.length > 0) {
                        item.roles.forEach((role) => {
                            this.form.roleInt.push(role.role);
                        });
                    }
                }
            },
            submitForm() {
                this.$refs.form.validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    delete this.form.createTime;
                    delete this.form.modifyTime;
                    if(this.form.roles) {
                        delete this.form.roles;
                    }
                    this.$store.dispatch('system/menuItem/save',this.form).then((res) => {
                        if (res.code === '200') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.$emit('closeHandler',this.form, this.operation);
                            this.closeDialog();
                        } else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                });
            },
            closeDialog() {
                this.$refs.form.resetFields();
                this.form = {
                    name: '',
                    code: '',
                    state: 2,
                    menuIcon: '',
                    path: '',
                    roleInt: [1,2,3]
                };
                this.showFlag = false;
            },
            changeIcon() {
                this.$refs.iconDialog.show(this.form);
            }
        }
    }
</script>
<style scoped>
    .iconfont {
        display: block;
        width: 40px;
        height: 40px;
        border: 1px solid lightgray;
        text-align: center;
        cursor: pointer;
        font-size: 30px;
    }
</style>